import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { ACTION_TYPES } from './actions';

const composeEnchancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  || compose;
const middlewares = [thunk];

const initialState = {
  restaurantsListData: null,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.SAVE_RESTAURANTS: {
      const { payload } = action;

      return {
        ...state,
        restaurantsListData: payload,
      };
    }

    default:
      return state;
  }
}

const store = createStore(
  reducer,
  composeEnchancers(applyMiddleware(...middlewares))
);

export default store;
